import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StoreState } from '~/reducer';

import { leaveManageWorkspace } from '../../layoutSlice';
import { myWorkspaceLayoutStoreStateSelector } from '../../selectors';

export interface UseManageWorkspaceControlsOutput {
  inEditMode: boolean;
}

export const useManageWorkspaceControls =
  (): UseManageWorkspaceControlsOutput => {
    const inEditMode = useSelector((state: StoreState) => {
      return !!myWorkspaceLayoutStoreStateSelector(state).manageWorkspace;
    });

    const dispatch = useDispatch();

    useEffect(() => {
      return () => {
        dispatch(leaveManageWorkspace());
      };
    }, [dispatch]);

    return {
      inEditMode,
    };
  };
